export default "__VITE_ASSET__DyD81Fp1__"